.text {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
}

.paragraph,
.list {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
  overflow-wrap: anywhere;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  padding-left: var(--pgm-sys-spacing-6);
}

.link {
  color: var(--pgm-sys-color-primary);
  text-decoration: underline;
}
